'use strict';

/*@ngInject*/
module.exports = function LoginModalController($uibModalInstance, $rootScope, publicUsersService, $q, $window, toastr, authService, sharedService, $http, onLogin, startLogin, $timeout, $filter) {
    var vm = this;
    vm.modalInstance = $uibModalInstance;

    var RESPONSE_STATUS_OK = 'ok';

    vm.rootScope = $rootScope;
    vm.startLogin = startLogin;
    vm.passesError = false;
    vm.onLogin = onLogin;
    vm.viewMode = 'logIn';
    vm.title = vm.viewMode === 'logIn' ? 'signing_in' : 'registration';
    vm.user = {
        email: '',
        firstname: '',
        lastname: '',
        pass1: '',
        pass2: ''
    };
    vm.passwordPattern = publicUsersService.passwordPattern;
    vm.phonePattern = sharedService.getPhonePattern();
    vm.emailPattern = sharedService.getEmailPattern();

    vm.$onInit = function () {
        if (vm.startLogin) {
            authService.getTaraUserFromSession().then(function (response) {
                if (response.data !== 'nok') {
                    if (response.data.authentication_method) {
                        vm.user = response.data;
                        vm.setSignInMode();
                    } else {
                        vm.rootScope.showErrorModal = true;
                        vm.rootScope.errorMessage = response.data.errorMessage || 'login_failed';
                    }
                }
            });
        }
    };

    vm.signInFacebook = function () {
        return window.location.href = $rootScope.rootUrl + 'facebook/login';
    };

    vm.signInGoogle = function () {
        return window.location.href = $rootScope.rootUrl + 'google/login';
    };

    vm.close = function () {
        vm.setLogInMode();
        vm.rootScope.isModalOpen = false;
        vm.modalInstance.close();
    };

    vm.setSignInMode = function () {
        vm.viewMode = 'signIn';
        vm.title = 'registration';
    };

    vm.setRestorePasswordMode = function () {
        return vm.viewMode = 'restorePassword';
    };

    vm.setLogInMode = function () {
        vm.viewMode = 'logIn';
        vm.title = 'signing_in';
    };

    vm.signIn = function () {
        validateForm().then(function () {
            if (!vm.user.authentication_method) {
                vm.user.authentication_method = 'EMAIL';
            }
            publicUsersService.registerUser(vm.user).then(function (response) {
                if (response.data === RESPONSE_STATUS_OK) {
                    vm.onLogin();
                    vm.rootScope.showSuccessModal = true;
                    vm.rootScope.successMessage = 'registration_confirmation_sent_to_email';
                    vm.user.password = null;
                    vm.viewMode = 'logIn';
                } else {
                    vm.rootScope.showErrorModal = true;
                    vm.rootScope.errorMessage = 'user_exists_with_given_email';
                }
            });
        });
    };

    vm.logIn = function () {
        vm.passesError = false;

        validateForm().then(function () {
            if (vm.viewMode === 'mobileId') {
                vm.mobileIdLogin();
            } else {
                $http({
                    method: 'POST',
                    url: 'publicUsers/login',
                    data: { email: vm.user.email, password: vm.user.pass1 }
                }).then(function successCallback(response) {
                    if (response.data === RESPONSE_STATUS_OK) {
                        vm.onLogin();
                        $window.location.reload();
                    } else {
                        vm.rootScope.showErrorModal = true;
                        vm.rootScope.errorMessage = response.data;
                        $rootScope.loggedIn = false;
                    }
                });
            }
        });
    };

    vm.taraLogin = function () {
        authService.getTaraLoginUrl().then(function (response) {
            window.location = response.data;
        });
    };

    function validateForm() {
        return $q(function (resolve, reject) {
            vm.showErrors = false;
            vm.isConfirmedPassIncorrect();
            if (vm.publicUserForm.$invalid || vm.passesError) {
                vm.showErrors = true;
                vm.rootScope.showErrorModal = true;
                vm.rootScope.errorMessage = vm.getErrorMessage();
                $rootScope.loggedIn = false;
                vm.readErrors();
                reject();
            } else {
                resolve();
            }
        });
    }

    vm.getErrorMessage = function () {
        var message = [];
        if (vm.viewMode === 'signIn') {
            if (vm.publicUserForm.firstname.$error.required) {
                message.push($filter('translate')('first_name_required'));
            }
            if (vm.publicUserForm.lastname.$error.required) {
                message.push($filter('translate')('last_name_required'));
            }
        }
        if (vm.publicUserForm.email.$error.required) {
            message.push($filter('translate')('login_email_required'));
        }
        if (vm.publicUserForm.email.$error.pattern) {
            message.push($filter('translate')('login_email_wrong_format'));
        }

        if (vm.viewMode !== 'restorePassword') {
            if (vm.publicUserForm.pass1.$error.required) {
                message.push($filter('translate')('login_password_required'));
            }
            if (vm.publicUserForm.pass1.$error.pattern) {
                message.push($filter('translate')('login_password_wrong_format'));
            }
        }

        if (vm.viewMode === 'signIn') {
            if (vm.publicUserForm.pass2.$error.required) {
                message.push($filter('translate')('login_password_repeat_required'));
            }
            if (vm.passesError && !vm.publicUserForm.pass2.$error.required) {
                message.push($filter('translate')('login_check_password_correctness'));
            }
        }

        return message.length > 0 ? message.join('. ') + '.' : '';
    };

    vm.isConfirmedPassIncorrect = function () {
        if (!vm.user.authentication_method && vm.user.pass1 && vm.user.pass2) {
            vm.passesError = vm.user.pass1 !== vm.user.pass2;
        } else {
            vm.passesError = false;
        }
    };

    vm.restorePassword = function () {
        validateForm().then(function () {
            publicUsersService.restorePassword(vm.user.email).then(function (response) {
                if (response.data === RESPONSE_STATUS_OK) {
                    vm.viewMode = 'logIn';
                    vm.rootScope.showSuccessModal = true;
                    vm.rootScope.successMessage = 'a_password_recovery_email_has_been_sent_to_you';
                    vm.rootScope.loginModalOpened = false;
                } else {
                    vm.rootScope.showErrorModal = true;
                    vm.rootScope.errorMessage = 'user_not_found_or_disabled';
                    vm.rootScope.loginModalOpened = false;
                }
            });
        });
    };

    vm.readErrors = function () {
        $timeout(function () {
            document.getElementById('message-container').focus();
            var firstInvalidElement = document.querySelector(':invalid');
            if (firstInvalidElement) {
                firstInvalidElement.focus();
            }
        });
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/login-modal.controller.js
 **/